import { IApplicationState } from '../../types/redux';
import { selectProjectsList } from '../projects';
import { selectPagination } from './selectPagination';

export const selectIsMoreButtonShown = (state: IApplicationState): boolean => {
  const { total } = selectPagination(state);
  const projectList = selectProjectsList(state);

  return total > projectList.length;
};
